import { useTranslation } from 'react-i18next';

interface LoadingScreenProps {
  /** 表示メッセージ */
  message?: string;
}

/**
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business 全画面ローディング。エメラルドスピナーとステータスメッセージをglass morphismカードで表示
 * @graph-connects none
 */
export function LoadingScreen({ message }: LoadingScreenProps) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[var(--color-bg-base)]">
      <div className="gradient-orb gradient-orb-1" />
      <div className="gradient-orb gradient-orb-2" />
      <div className="glass rounded-2xl p-8 flex flex-col items-center gap-4">
        <div className="loading-spinner" />
        <p className="text-[var(--color-text-muted)] text-sm">{message ?? t('status.loading')}</p>
      </div>
    </div>
  );
}
